
import Vue from 'vue'
import { ProductCategory } from '@/model/productCategory'
import { MENU_PAGES } from '@/categories/const'
import BaseImage from '@/common/components/BaseImage.vue'
import scrollTo from '@/common/animatedScrollTo'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'

export default Vue.extend({
  name: 'MobileCategories',
  components: {
    BaseImage
  },
  props: {
     productCategories: {
      type: Array as () => ProductCategory[],
      required: true
    }
  },
  data(): {
    activeMenu: string
    activeParentCategory: number
    activeChildCategories: number[]
  } {
    return {
      activeMenu: MENU_PAGES.PARENT_CAT,
      activeParentCategory: -1,
      activeChildCategories: []
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    childCategories(): ProductCategory[] {
      return this.productCategories.find(item => item.id === this.activeParentCategory)?.child_categories || []
    },
    categoryHeader(): string {
      return this.productCategories.find(item => item.id === this.activeParentCategory)?.short_display_name || ''
    }
  },
  watch: {
    activeMenu() {
      this.activeChildCategories = []
    }
  },
  methods: {
    onSelectParentCategory(item: ProductCategory) {
      if (item.child_categories && item.child_categories.length > 0) {
        scrollTo(0,0)
        this.activeParentCategory = item.id
        this.activeMenu = MENU_PAGES.CHILD_CAT
      } else {
        window.location.href = item.url
      }
    },
    activateParentCategoryMenu() {
      this.activeMenu = MENU_PAGES.PARENT_CAT
    },
    clickOnChildCategory(item: ProductCategory) {
      if (item.child_categories && item.child_categories.length > 0) {
        if (this.activeChildCategories.includes(item.id)) {
          this.activeChildCategories.splice(this.activeChildCategories.indexOf(item.id),1)
        }
        else this.activeChildCategories.push(item.id)
      }
    },
    isChildCategorySelected(item: ProductCategory) {
      return this.activeChildCategories.includes(item.id)
    }
  }
})
